import i18n, { InitOptions } from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { fallbackLanguage, loadPath } from "./config";

export const initializei18Next = () => {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: [fallbackLanguage],
      backend: {
        loadPath: (lngs) => {
          // biome-ignore lint/suspicious/noExplicitAny: <explanation>
          const opts: any = i18n.options;
          if (opts?.customerId) {
            return loadPath.replace(
              "{{lng}}",
              `${lngs[0]}_${opts?.customerId}`
            );
          }
          return loadPath;
        },
        crossDomain: true
      },
      load: "currentOnly",
      baseLng: "",
      customerId: "",
      debug: false,
      nonExplicitSupportedLngs: true,
      postProcess: ["InjectTranslationKey"],
      returnObjects: true,
      interpolation: { escapeValue: false },
      returnEmptyString: false,
      react: {
        bindI18n: "languageChanged editorSaved",
        transKeepBasicHtmlNodesFor: ["span"]
        //  defaultTransParent: WrapperComp
      }
    } as InitOptions);
};

export default i18n;
